import React, { useState } from 'react';
import { Clock, Building, Calendar } from 'lucide-react';
import { StepButtons } from '../ui';

interface ConstraintsStepProps {
  value: {
    constraints: {
      urgent: boolean;
      historicArea: boolean;
      desiredDelay: number;
    };
  };
  onChange: (field: string, value: any) => void;
  onNext: () => void;
  onBack: () => void;
}

export const ConstraintsStep: React.FC<ConstraintsStepProps> = ({
  value,
  onChange,
  onNext,
  onBack
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleConstraintChange = (field: keyof typeof value.constraints, newValue: any) => {
    onChange('constraints', {
      ...value.constraints,
      [field]: newValue
    });
  };

  const handleFocus = () => {
    setIsFocused(true);
    handleConstraintChange('desiredDelay', '');
  };

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-semibold text-primary">Contraintes et délais</h2>
      
      <div className="grid grid-cols-2 gap-4">
        <button
          type="button"
          onClick={() => handleConstraintChange('urgent', !value.constraints.urgent)}
          className={`
            card flex items-center p-4 transition-all
            ${value.constraints.urgent ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
          `}
        >
          <Clock className={`h-5 w-5 mr-2 ${value.constraints.urgent ? 'text-primary' : 'text-neutral-600'}`} />
          <span className={value.constraints.urgent ? 'text-primary' : 'text-neutral-700'}>
            Travaux urgents
          </span>
        </button>

        <button
          type="button"
          onClick={() => handleConstraintChange('historicArea', !value.constraints.historicArea)}
          className={`
            card flex items-center p-4 transition-all
            ${value.constraints.historicArea ? 'ring-2 ring-primary bg-primary/5' : 'hover:bg-neutral-50'}
          `}
        >
          <Building className={`h-5 w-5 mr-2 ${value.constraints.historicArea ? 'text-primary' : 'text-neutral-600'}`} />
          <span className={value.constraints.historicArea ? 'text-primary' : 'text-neutral-700'}>
            Zone classée
          </span>
        </button>
      </div>

      <div className="card">
        <div className="flex items-center mb-4">
          <Calendar className="h-6 w-6 text-primary mr-3" />
          <span className="font-medium text-neutral-800">Délai souhaité</span>
        </div>
        <div className="flex items-center space-x-2">
          <input
            type="number"
            value={isFocused ? value.constraints.desiredDelay || '' : value.constraints.desiredDelay || 6}
            onChange={(e) => handleConstraintChange('desiredDelay', parseInt(e.target.value) || '')}
            onFocus={handleFocus}
            onBlur={() => setIsFocused(false)}
            min="1"
            max="24"
            className="input w-32"
          />
          <span className="text-neutral-500">mois</span>
        </div>
      </div>

      <StepButtons onNext={onNext} onBack={onBack} />
    </div>
  );
};

export default ConstraintsStep;